module.exports = __webpack_public_path__ + "shattered.ea2316224d45899c59bc.png";


//////////////////
// WEBPACK FOOTER
// D:/SSW/Project/GSDP/Angular/gsdp_core_angular/src/assets/styles/patterns/shattered.png
// module id = ../../../../../src/assets/styles/patterns/shattered.png
// module chunks = styles